if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', homeCareCostTest);
} else {
    homeCareCostTest();
}

function homeCareCostTest() {
    handleResponsivePlaceholder();
}

function handleResponsivePlaceholder() {
    const inputSelector = '.housing-finder-home-care-cost-test .senior-finder-zip-form.v2.desktop-v .flex-grid .zip-form .senior-finder-form .form-container .input-container input';
    const input = document.querySelector(inputSelector);

    if (!input) return;

    const originalPlaceholder = input.placeholder || '';
    const mobilePlaceholder = 'Enter your zip...';

    function updatePlaceholder() {
        if (window.innerWidth < 992) { // desktop-down breakpoint
            input.placeholder = mobilePlaceholder;
        } else {
            input.placeholder = originalPlaceholder;
        }
    }

    updatePlaceholder();

    window.addEventListener('resize', updatePlaceholder);
}